/* istanbul ignore file */
import { ShowSection, SectionRow, FieldListLayout, ShowPageLayout } from 'framework/ui/layout';
import { BooleanField, TextField } from 'framework/ui/field';
import { UPDATE_SERVICE } from 'domain/shared/service';
import EditServiceButton from 'domain/organization/service/shared/button/EditServiceButton';
import ViewServicePageMenu from 'domain/organization/service/Show/ViewServicePageMenu';
import SingleServiceBreadcrumbs from 'domain/organization/service/shared/SingleServiceBreadcrumbs';
import ServiceEntityHeader from 'domain/organization/service/shared/ServiceEntityHeader';
import { EmployeeLinkField, EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import { BudgetLinkField, BudgetChildLinkField } from 'domain/shared/budget';
import { ArtifactStorageFileInformationSection } from 'domain/shared/artifactStorage';
import ProjectField from 'infrastructure/integrations/redmine/ProjectField';

const ViewServicePageContent = () => {
  return (
    <ShowPageLayout
      headerButtons={[<EditServiceButton key="edit-service" permissionToCheck={UPDATE_SERVICE} isVisible={false} />]}
      menu={<ViewServicePageMenu />}
      breadcrumbs={<SingleServiceBreadcrumbs />}
      entityHeader={<ServiceEntityHeader />}
      hasSeparateSections
    >
      <ShowSection title="Service Information">
        <SectionRow>
          <TextField source="name" label="Name" />
          <EmployeeLinkField source="ownerId" nameSource="ownerName" label="Owner" />
          <ProjectField source="taskTrackerAlias" nameSource="taskTrackerAlias" label="Redmine Project Alias" />
        </SectionRow>
        <SectionRow>
          <BudgetLinkField label="Default Budget" source="defaultBudgetId" nameSource="defaultBudget.name" />
          <FieldListLayout source="availableBudgets" label="Available Budgets">
            <BudgetChildLinkField />
          </FieldListLayout>
          <BooleanField source="assignmentForbidden" label="Assignment Forbidden" />
        </SectionRow>
        <SectionRow>
          <EmployeeLinkFieldWithNameLoading source="staffingCoordinatorAlias" label="Staffing Coordinator" />
        </SectionRow>
      </ShowSection>
      <ArtifactStorageFileInformationSection
        title="Service Approved Budget"
        source="companyServiceBudget"
        prevSource="companyServiceBudget"
        isVisible={data => data.companyServiceBudget != null}
      />
    </ShowPageLayout>
  );
};

export default ViewServicePageContent;
